import React from 'react';
import type { CouncilCost, EventLogEntry } from '../../../../types/council';
import type { Persona } from '../../../../types/persona';
import type { CockpitRosterEntry } from './cockpitDerive';
import { PeersTab } from './tabs/PeersTab';
import { CostTab } from './tabs/CostTab';

export type CockpitTab = 'peers' | 'cost' | 'tools' | 'history';
const TABS: { key: CockpitTab; label: string }[] = [
  { key: 'peers', label: 'Peers' }, { key: 'cost', label: 'Cost' },
  { key: 'tools', label: 'Tools' }, { key: 'history', label: 'History' },
];

export const CockpitRolldown: React.FC<{
  activeTab: CockpitTab; onTab: (t: CockpitTab) => void;
  cost?: CouncilCost | null; roster: CockpitRosterEntry[]; personasById: Record<string, Persona>;
  entries: EventLogEntry[]; sessionId: string; darkMode: boolean; historySlot: React.ReactNode;
}> = ({ activeTab, onTab, cost, roster, personasById, entries, sessionId, darkMode, historySlot }) => {
  const wrap = darkMode ? 'bg-gray-900/97 border-gray-700' : 'bg-white/97 border-gray-300';
  return (
    <div data-testid="cockpit-rolldown" className={`mt-1 rounded-md border shadow-lg ${wrap}`} style={{ maxHeight: '45vh' }}>
      <div className="shrink-0 flex gap-1 px-2 py-1 border-b border-inherit">
        {TABS.map(t => (
          <button key={t.key} type="button" onClick={() => onTab(t.key)}
            className={`px-2 py-0.5 rounded text-[11px] ${activeTab === t.key
              ? 'bg-blue-600 text-white' : darkMode ? 'bg-gray-800 text-gray-300' : 'bg-gray-100 text-gray-600'}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="overflow-y-auto" style={{ maxHeight: 'calc(45vh - 32px)' }}>
        {activeTab === 'peers' && <PeersTab sessionId={sessionId} roster={roster} personasById={personasById} entries={entries} darkMode={darkMode} />}
        {activeTab === 'cost' && <CostTab cost={cost} entries={entries} darkMode={darkMode} />}
        {activeTab === 'tools' && (
          <div className="px-3 py-6 text-center text-[11px] opacity-50">Per-tool histogram arrives in Slice 2</div>
        )}
        {activeTab === 'history' && historySlot}
      </div>
    </div>
  );
};
